module.exports = __webpack_public_path__ + "static/media/sastra-login-banner2.7ec8fa0f.jpg";